import { Component, OnInit, HostBinding, 
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomerDemographicsData, CustomerDemographicsService }  from './CustomerDemographics.service';


@Component({
  template: require('./CustomerDemographicsDetails.component.html'),
  providers: [CustomerDemographicsService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerDemographicsDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
  
	objCustomerDemographics: CustomerDemographicsData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastsManager,
		private CustomerDemographicsService: CustomerDemographicsService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCustomerDemographics = new CustomerDemographicsData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CustomerDemographicsService.getByID(+params['id']))
		.switchMap((params: Params) => this.CustomerDemographicsService.getByID(params['id']))
		.subscribe((item: CustomerDemographicsData) => this.objCustomerDemographics = item);
		this.getLookups();
	}

	deleteCustomerDemographics(id: number) {
		if (window.confirm('Are you sure you want to delete this CustomerDemographics?') == true)
		{
			this.CustomerDemographicsService.deleteCustomerDemographics(this.objCustomerDemographics.CustomerTypeID.toString())
			.subscribe(record => this.router.navigate(['/CustomerDemographics']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('CustomerDemographics record deleted successfully...'); }
			);
		}
	}
	gotoCustomerDemographicsEdit() {
		this.router.navigate(['/CustomerDemographics', this.objCustomerDemographics.CustomerTypeID]);
	}

	gotoCustomerDemographics() {
		this.router.navigate(['/CustomerDemographics']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerDemographics/CustomerDemographicsDetails.component.ts